import 'angular';
import AppConstants from '../gorillaboy/AppConstants';

interface AccessControlService {
    describeOrganizationAccessControlPolicy: Function;
    updateOrganizationAccessControlPolicy: Function;
}

AccessControlServiceFactory.$inject = ['$rootScope',
    '$http',
    '$q',
    'EndpointService'];

function AccessControlServiceFactory($rootScope, $http, $q, EndpointService) {
    const httpMethods = AppConstants.HttpMethods;

    function SERVICE_ROOT() {
        return EndpointService.endpoint() + 'accesscontrols/';
    }

    const accessControlService: AccessControlService = {

        describeOrganizationAccessControlPolicy: () => {
            var config = {
                url: SERVICE_ROOT(),
                method: httpMethods.GET
            };
            return $http(EndpointService.tokenize(config));
        },

        updateOrganizationAccessControlPolicy: (cidrList) => {
            var config = {
                url: SERVICE_ROOT(),
                method: httpMethods.PUT,
                data: {
                    AccessControlPolicy: {
                        AllowedCIDRList: cidrList
                    }
                }
            };
            return $http(EndpointService.tokenize(config));
        }
    }

    return accessControlService;
}

angular.module('GorillaBoy.services')
    .factory('AccessControlService', AccessControlServiceFactory);

export {
    AccessControlService
}